import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const HostOnboardingOriginalsContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingOriginals'
    ),
);
const HostOnboardingJoinContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingJoin'
    ),
);
const HostOnboardingFeedbackContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-onboarding" */ './pages/HostOnboardingFeedback'
    ),
);

const HostOnboardingRedirect = () => {
  useEffect(() => {
    window.location.replace(`${BECOME_A_HOST_HOST}/overview`);
  }, []);

  return null;
};

export const hostOnboardingOriginalsJoinRoute: RouteDescriptor = {
  id: 'host-onboarding.originals.join',
  path: `${basePath}/host/onboarding/withlocals-originals/:tier/join`,
  label: 'Host Onboarding Join Originals',
  audience: 'host',
  layout: 'navigational',
  module: 'host-onboarding',
};

export const hostOnboardingOriginalsRoute: RouteDescriptor = {
  id: 'host-onboarding.originals',
  path: `${basePath}/host/onboarding/withlocals-originals`,
  label: 'Host Onboarding Originals',
  audience: 'host',
  layout: 'navigational',
  module: 'host-onboarding',
};

export const hostOnboardingFeedbackRoute: RouteDescriptor = {
  id: 'host-onboarding.feedback',
  path: `${basePath}/host/onboarding/feedback`,
  label: 'Host Onboarding Feedback',
  audience: 'host',
  layout: 'navigational',
  module: 'host-onboarding',
};

export const hostOnboardingRedirectRoute: RouteDescriptor = {
  id: 'host-onboarding.redirect',
  path: `${basePath}/host/onboarding`,
  label: 'Host Onboarding Redirect',
  audience: 'host',
  layout: 'standalone',
  module: 'host-onboarding',
};

export const hostOnboardingRoutes = [
  createNavigationalRoute({
    key: hostOnboardingOriginalsJoinRoute.id,
    id: hostOnboardingOriginalsJoinRoute.id,
    path: hostOnboardingOriginalsJoinRoute.path,
    hideFooter: true,
    component: HostOnboardingJoinContainer as any,
    showBottomNavigation: true,
    noNavbar: isCordova(),
    nonFixedNavbar: true,
    handle: createRouteHandle(hostOnboardingOriginalsJoinRoute),
  }),
  createNavigationalRoute({
    key: hostOnboardingOriginalsRoute.id,
    id: hostOnboardingOriginalsRoute.id,
    path: hostOnboardingOriginalsRoute.path,
    hideFooter: true,
    component: HostOnboardingOriginalsContainer as any,
    showBottomNavigation: true,
    noNavbar: isCordova(),
    nonFixedNavbar: true,
    handle: createRouteHandle(hostOnboardingOriginalsRoute),
  }),
  createNavigationalRoute({
    key: hostOnboardingFeedbackRoute.id,
    id: hostOnboardingFeedbackRoute.id,
    path: hostOnboardingFeedbackRoute.path,
    hideFooter: true,
    component: HostOnboardingFeedbackContainer as any,
    showBottomNavigation: true,
    noNavbar: isCordova(),
    nonFixedNavbar: true,
    handle: createRouteHandle(hostOnboardingFeedbackRoute),
  }),
  <Route
    key={hostOnboardingRedirectRoute.id}
    id={hostOnboardingRedirectRoute.id}
    path={hostOnboardingRedirectRoute.path}
    handle={createRouteHandle(hostOnboardingRedirectRoute)}
    element={<HostOnboardingRedirect />}
  />,
];

export const hostOnboardingRouteDescriptors = [
  hostOnboardingOriginalsJoinRoute,
  hostOnboardingOriginalsRoute,
  hostOnboardingFeedbackRoute,
  hostOnboardingRedirectRoute,
];

export default hostOnboardingRoutes;
